export const FETCH_ALERTS = 'FETCH_ALERTS';
export const STORE_ALERTS = 'STORE_ALERTS';
export const SNOOZE_ALERT = 'SNOOZE_ALERT';
export const RESOLVE_ALERT = 'RESOLVE_ALERT';
export const DELETE_ALL_ALERTS = 'DELETE_ALL_ALERTS';